import { render, staticRenderFns } from "./budget-forms-template12.vue?vue&type=template&id=6896c148&scoped=true&"
import script from "./budget-forms-template12.vue?vue&type=script&lang=js&"
export * from "./budget-forms-template12.vue?vue&type=script&lang=js&"
import style0 from "./budget-forms-template12.vue?vue&type=style&index=0&id=6896c148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896c148",
  null
  
)

export default component.exports